// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"9dd8c606","528":"58c9bdfa","643":"a77a3418"}[chunkId] + ".chunk.css";
};